module.exports = __webpack_public_path__ + "img/unknown.83dd4569.png";